module.exports = __webpack_public_path__ + "static/media/brego3594.cfb1a016.jpg";